export const ComercioData = [
    {
        "id": 1,
        "image": "https://destinonegocio.com/wp-content/uploads/2015/12/ico-destinonegocio-carniceria-istock-getty-images-1030x767.jpg",
        "name": "Carnes de Res 1",
        "categoria": "Carniceria",
        "distancia": 400,
        "calificacion": 4
    },
    {
        "id": 2,
        "image": "https://destinonegocio.com/wp-content/uploads/2015/12/ico-destinonegocio-carniceria-istock-getty-images-1030x767.jpg",
        "name": "Carnes de Res 1",
        "categoria": "Carniceria",
        "distancia": 400,
        "calificacion": 4
    },
    {
        "id": 3,
        "image": "https://destinonegocio.com/wp-content/uploads/2015/12/ico-destinonegocio-carniceria-istock-getty-images-1030x767.jpg",
        "name": "Carnes de Res 1",
        "categoria": "Carniceria",
        "distancia": 400,
        "calificacion": 4
    },
    {
        "id": 4,
        "image": "https://destinonegocio.com/wp-content/uploads/2015/12/ico-destinonegocio-carniceria-istock-getty-images-1030x767.jpg",
        "name": "Carnes de Res 1",
        "categoria": "Carniceria",
        "distancia": 400,
        "calificacion": 4
    },
    {
        "id": 5,
        "image": "https://destinonegocio.com/wp-content/uploads/2015/12/ico-destinonegocio-carniceria-istock-getty-images-1030x767.jpg",
        "name": "Carnes de Res 1",
        "categoria": "Carniceria",
        "distancia": 400,
        "calificacion": 4
    },
    {
        "id": 6,
        "image": "https://destinonegocio.com/wp-content/uploads/2015/12/ico-destinonegocio-carniceria-istock-getty-images-1030x767.jpg",
        "name": "Carnes de Res 1",
        "categoria": "Carniceria",
        "distancia": 400,
        "calificacion": 4
    },
    {
        "id": 7,
        "image": "https://destinonegocio.com/wp-content/uploads/2015/12/ico-destinonegocio-carniceria-istock-getty-images-1030x767.jpg",
        "name": "Carnes de Res 1",
        "categoria": "Carniceria",
        "distancia": 400,
        "calificacion": 4
    },
    {
        "id": 8,
        "image": "https://destinonegocio.com/wp-content/uploads/2015/12/ico-destinonegocio-carniceria-istock-getty-images-1030x767.jpg",
        "name": "Carnes de Res 1",
        "categoria": "Carniceria",
        "distancia": 400,
        "calificacion": 4
    },
    {
        "id": 9,
        "image": "https://destinonegocio.com/wp-content/uploads/2015/12/ico-destinonegocio-carniceria-istock-getty-images-1030x767.jpg",
        "name": "Carnes de Res 1",
        "categoria": "Carniceria",
        "distancia": 400,
        "calificacion": 4
    },
    {
        "id": 10,
        "image": "https://destinonegocio.com/wp-content/uploads/2015/12/ico-destinonegocio-carniceria-istock-getty-images-1030x767.jpg",
        "name": "Carnes de Res 1",
        "categoria": "Carniceria",
        "distancia": 400,
        "calificacion": 4
    },
]